import React from "react";

export default function CandidateCharacteristics() {
  return <div>CandidateCharacteristics</div>;
}
